import axios from 'axios'
// const url = 'http://34.80.198.150:7777/api/'
const url =
  process.env.NODE_ENV === 'production'
    // ? process.env.API_HOST
    ? 'https://server.ezwash.com.tw/'
    : 'http://localhost:1688/'

const api = {
  user_check: url + 'user/user_check',
  join: url + 'user/join',
  login: url + 'user/login',
  send_verification_code: url + 'user/send_verification_code',
  code_check: url + 'user/code_check',
  getUserInfo: url + 'user/getUserInfo',
  updateUserLineUserID: url + 'user/update_lineID',
  updateUserInfo: url + 'user/updateUserInfo'
}

export function getUserInfo (params) {
  return axios.post(api.getUserInfo, params)
}

export function updateUserInfo (params) {
  return axios.post(api.updateUserInfo, params)
}

export function updateUserLineUserID (params) {
  return axios.post(api.updateUserLineUserID, params)
}


export function userCheck (params) {
  return axios.post(api.user_check, params)
}

export function join (params) {
  return axios.post(api.join, params)
}

export function login (params) {
  return axios.post(api.login, params)
}

export function sendVerificationCode (params) {
  return axios.post(api.send_verification_code, params)
}

export function codeCheck (params) {
  return axios.post(api.code_check, params)
}
